import React from "react";
import Logo from "../../../../Assets/Images/GroupXCZ.png";

const UploadStatusView = () => {
  return (
    <div className="my-4">
      <div className="card bg-dark">
        <h4 className="text-warning p-4">
          Your Video Upload successfully Done..!
        </h4>
        <hr className="HRx" />
        <center className="mt-5 mb-5">
          <img src={Logo} alt="" className="mt-5" />
          <h5 className="text-warning p-4 mb-5">
            Your Video Upload successfully Done..!
          </h5>
        </center>
      </div>
    </div>
  );
};

export default UploadStatusView;
